import React from 'react'
import { css } from 'glamor'
import colors from '../../style/colors'
import { fontWeight } from '../../style/sizes'
import SubscribeButton from '../subscribeButton'
import notificationImage from '../../assets/notification.svg'

const CSS = {
  main: css({
    top: '-90px',
    margin: '0 auto',
    width: '828px',
    maxWidth: '90%',
    padding: '30px 50px 80px 50px',
    boxShadow: '0 5px 25px 0 rgba(0,0,0,0.17)',
    position: 'relative',
    background: colors.white,
    borderRadius: '4px',
    overflow: 'hidden',
    ' h4': {
      maxWidth: '529px',
      color: colors.navy,
      fontSize: '40px',
      fontWeight: fontWeight.bold,
      lineHeight: '53px',
      marginTop: '20px'
    },
    ' input[type="email"]': {
      width: '100%',
      height: '50px',
      fontSize: '14px',
      fontWeight: fontWeight.normal,
      border: 'none',
      borderBottom: `2px solid ${colors.grey2}`,
      padding: '10px 0',
      marginBottom: '15px',
      outline: 'none',
      transition: 'border-bottom .2s',
      ':focus': {
        borderBottom: `2px solid ${colors.blue}`
      }
    }
  }),
  buttonContainer: css({
    textAlign: 'right'
  }),
  hubspotForm: css({
    ' .hs-form-field > label': {
      display: 'none'
    },
    ' .hs-button': {
      display: 'none'
    }
  })
}

class Subscribe extends React.Component {
  constructor (props) {
    super(props)

    this.submit = this.submit.bind(this)
    this.uniqueId = `hubspotFrom-${Date.now()}`
  }

  componentDidMount () {
    this.showHubSpotForm()
  }

  showHubSpotForm () {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '4265482',
          formId: 'f11cbc2e-0d43-48c1-a8eb-b6676457044d',
          formInstanceId: this.uniqueId,
          target: `#${this.uniqueId}`,
          css: ''
        })
      }
    })
  }

  submit () {
    const form = this.formWrapperElement && this.formWrapperElement.querySelector('form')
    return form.submit()
  }

  render () {
    return (
      <div {...CSS.main}>
        <div><img src={notificationImage} alt='Subscribe to notifications' /></div>
        <h4>Get notified when new SaaS is added</h4>
        <div className='row'>
          <div className='col-xs-12 col-md-9'>
            <div id={this.uniqueId} {...CSS.hubspotForm} ref={ref => (this.formWrapperElement = ref)} />
          </div>
          <div className='col-xs-12 col-md-3'>
            <div className='clear' {...CSS.buttonContainer}>
              <SubscribeButton backgroundColor={colors.blue} hoverBackgroundColor={colors.navy} onClick={this.submit} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Subscribe



// WEBPACK FOOTER //
// ./src/components/subscribe/index.js